import { Alert } from '@creditornot/cb-alert';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

const TaxInfoResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

type Props = {
  taxIdLabel: string;
};

export const TaxInfoResultAlert = ({ taxIdLabel }: Props) => {
  const { formatMessage: t } = useIntl();

  return (
    <Alert
      variant="warning"
      title={t({
        id: 'compliance.kyb.sections.basic-info.business-information.tax-verification.inconclusive-verification-field-warning-title',
      })}
    >
      <TaxInfoResultContainer>
        <T.Body3>
          <FormattedMessage
            id="compliance.kyb.sections.basic-info.business-information.tax-verification.inconclusive-verification-field-warning-description"
            values={{
              field: taxIdLabel,
            }}
          />
        </T.Body3>

        <T.Body3>
          <FormattedMessage
            id="compliance.kyb.sections.basic-info.business-information.tax-verification.inconclusive-verification-field-warning-action"
            values={{
              field: taxIdLabel,
            }}
          />
        </T.Body3>
      </TaxInfoResultContainer>
    </Alert>
  );
};
